import React from 'react';

const WorksheetSmartAssist = ({ suggestions = [], onApplySuggestion, onDismiss }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {suggestions.map((item, idx) => (
        <div key={idx} className="ws-smart-assist-banner">
          <div className="ws-smart-assist-left">
            <div className="ws-smart-assist-icon">✨</div>
            <div>
              <div style={{ fontSize: '12.5px', fontWeight: 700, color: '#0369a1' }}>
                Smart Workbench Suggestion
              </div>
              <div className="ws-smart-assist-text">{item.suggestionText}</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {item.recommendedAction && (
              <button
                type="button"
                className="ws-btn ws-btn-primary ws-btn-sm"
                onClick={() => onApplySuggestion(item)}
              >
                Apply Suggestion
              </button>
            )}
            {onDismiss && (
              <button
                type="button"
                className="ws-btn ws-btn-outline ws-btn-sm"
                onClick={() => onDismiss(idx)}
                title="Dismiss"
              >
                ✕
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorksheetSmartAssist;
